import initialState from './initialState';
import {
  BI_TEMPLATE_ADMIN_GET_LIST_INIT,
  BI_TEMPLATE_ADMIN_GET_LIST_SUCCESS,
  BI_TEMPLATE_ADMIN_GET_LIST_FAILURE,
  BI_TEMPLATE_ADMIN_SAVE_INIT,
  BI_TEMPLATE_ADMIN_SAVE_SUCCESS,
  BI_TEMPLATE_ADMIN_SAVE_FAILURE,
  BI_TEMPLATE_ADMIN_SET_SAVE_DATA_BY_KEY,
  BI_TEMPLATE_ADMIN_SAVE_RESET,
  BI_TEMPLATE_ADMIN_DELETE_PREPARE_INIT,
  BI_TEMPLATE_ADMIN_DELETE_INIT,
  BI_TEMPLATE_ADMIN_DELETE_SUCCESS,
  BI_TEMPLATE_ADMIN_DELETE_FAILURE,
  BI_TEMPLATE_GET_POLYNOMIALS_LIST_INIT,
	BI_TEMPLATE_GET_POLYNOMIALS_LIST_SUCCESS,
	BI_TEMPLATE_GET_POLYNOMIALS_LIST_FAILURE,
  BI_TEMPLATE_GET_SYSTEM_DIMENSION_METRICS_INIT,
  BI_TEMPLATE_GET_SYSTEM_DIMENSION_METRICS_SUCCESS,
  BI_TEMPLATE_GET_SYSTEM_DIMENSION_METRICS_FAILURE,
  BI_TEMPLATE_GENERATE_TEMPLATE_INIT,
  BI_TEMPLATE_GENERATE_TEMPLATE_SUCCESS,
  BI_TEMPLATE_GENERATE_TEMPLATE_FAILURE,
  BI_TEMPLATE_ADMIN_RESET
} from '../../actions/biTemplateAdmin/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function biTemplateAdmin(state = initialState, action) {
  switch (action.type) {      
    case BI_TEMPLATE_ADMIN_GET_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "list");
    case BI_TEMPLATE_ADMIN_GET_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "list");
    case BI_TEMPLATE_ADMIN_GET_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "list");
     case BI_TEMPLATE_ADMIN_SAVE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitSave(initialState, state, action, "save");
    case BI_TEMPLATE_ADMIN_SAVE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessSave(initialState, state, action, "save");
    case BI_TEMPLATE_ADMIN_SAVE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureSave(initialState, state, action, "save");
    case BI_TEMPLATE_ADMIN_SET_SAVE_DATA_BY_KEY:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSetDataByKeySave(initialState, state, action, "save");
    case BI_TEMPLATE_ADMIN_SAVE_RESET:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateResetSave(initialState, state, action, "save");
    case BI_TEMPLATE_ADMIN_DELETE_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "delete");
    case BI_TEMPLATE_ADMIN_DELETE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "delete");
    case BI_TEMPLATE_ADMIN_DELETE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "delete");
    case BI_TEMPLATE_ADMIN_DELETE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "delete");
    case BI_TEMPLATE_GET_POLYNOMIALS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "polynomialsList");
    case BI_TEMPLATE_GET_POLYNOMIALS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "polynomialsList");
    case BI_TEMPLATE_GET_POLYNOMIALS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "polynomialsList");
    case BI_TEMPLATE_GET_SYSTEM_DIMENSION_METRICS_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "systemDimensionMetrics");
    case BI_TEMPLATE_GET_SYSTEM_DIMENSION_METRICS_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "systemDimensionMetrics");
    case BI_TEMPLATE_GET_SYSTEM_DIMENSION_METRICS_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "systemDimensionMetrics");
    case BI_TEMPLATE_GENERATE_TEMPLATE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "generateTemplate");
    case BI_TEMPLATE_GENERATE_TEMPLATE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "generateTemplate");
    case BI_TEMPLATE_GENERATE_TEMPLATE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "generateTemplate");
    case BI_TEMPLATE_ADMIN_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/biTemplateAdmin/index.js